import classNames from 'classnames'
import { InputNumber } from 'antd'
import styles from './Stepper.module.css'
import accurateCalc from 'accurate-core'
import { MyIcon } from '~/components/ui/MyIcon'

interface Props {
  value?: number
  onChange?: (n: number) => void
  step?: number
  digits?: number
  min?: number
  max?: number
  disabled?: boolean
  dark?: boolean
  className?: string
}

export default function Stepper({
  value,
  onChange,
  step = 1,
  digits = 0,
  min = Number.MIN_SAFE_INTEGER,
  max = Number.MAX_SAFE_INTEGER,
  disabled = false,
  dark = true,
  className,
}: Props) {
  const minDisabled = (value || 0) - step < min
  const maxDisabled = (value || 0) + step > max

  return (
    <div
      className={classNames(
        'flex items-center gap-2 select-none',
        styles.myStepper,
        [dark ? styles.myStepperDark : ''],
        className
      )}
      onClick={e => {
        e.stopPropagation()
      }}
    >
      <span
        className={classNames(
          'stepper-btn w-8 h-8 flex items-center justify-center cursor-pointer rounded',
          {
            'cursor-not-allowed': minDisabled,
          }
        )}
        onClick={() => {
          if (minDisabled) {
            return
          }
          onChange?.(accurateCalc.subtract(value || 0, step))
        }}
      >
        <MyIcon icon="minus" />
      </span>
      <InputNumber
        className={classNames('stepper-input !w-8')}
        onPressEnter={e => {
          e.preventDefault()
        }}
        disabled={disabled}
        min={min}
        max={max}
        value={value}
        onChange={val => {
          if (val! < min) {
            onChange?.(min)
          } else if (val! > max) {
            onChange?.(max)
          } else {
            onChange?.(Number(val?.toFixed(digits)))
          }
        }}
      />
      <span
        className={classNames(
          'stepper-btn w-8 h-8 flex items-center justify-center cursor-pointer rounded',
          {
            'cursor-not-allowed': maxDisabled,
          }
        )}
        onClick={() => {
          if (maxDisabled) {
            return
          }

          onChange?.(accurateCalc.add(value || 0, step))
        }}
      >
        <MyIcon icon="plus" />
      </span>
    </div>
  )
}
